import {
  apiGet,
  apiPost,
  apiDownload,
} from '../../api/index';
import { urlPlanning } from '../../api/urls';

export function getPlanning({
  id, page, onSuccess, onError,
}) {
  return apiGet(`${urlPlanning}/${id}/page-${page}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}
export function listOldPlannings({
  materiaMallaId, onSuccess, onError,
}) {
  return apiGet(`${urlPlanning}/list-old-plannings/${materiaMallaId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function savePlanning({
  page, paylaod, onSuccess, onError,
}) {
  return apiPost(`${urlPlanning}/${page}`, paylaod)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchPlanningFormData({ onSuccess, onError }) {
  return apiGet(`${urlPlanning}/form-data`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function download({ id, onSuccess, onError }) {
  return apiDownload(`${urlPlanning}/download/${id}`)
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Planeamiento.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
      if (onSuccess) onSuccess(blob);
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}
